import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyPeso = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 14H23.799C23.931 13.354 24 12.685 24 12C24 11.315 23.93 10.646 23.799 10H25C25.552 10 26 9.552 26 9C26 8.448 25.552 8 25 8H23.163C21.617 4.472 18.093 2 14.001 2H9.001C8.449 2 8.001 2.448 8.001 3V8H7.001C6.449 8 6.001 8.448 6.001 9C6.001 9.552 6.449 10 7.001 10H8.001V14H7.001C6.449 14 6.001 14.448 6.001 15C6.001 15.552 6.449 16 7.001 16H8.001V29C8.001 29.552 8.449 30 9.001 30C9.553 30 10.001 29.552 10.001 29V22H14.001C18.093 22 21.617 19.528 23.163 16H25C25.552 16 26 15.552 26 15C26 14.448 25.552 14 25 14ZM10 4H14C16.955 4 19.538 5.611 20.924 8H10V4ZM10 10H21.747C21.912 10.639 22 11.31 22 12C22 12.69 21.912 13.361 21.747 14H10V10ZM14 20H10V16H20.924C19.539 18.389 16.955 20 14 20Z" />
	</svg>
);

export default CurrencyPeso;
